<template>
    <div style="width: 100%; height: 100%;">
        <div class="custom-container">
            <v-row class="mt-n3" justify="center">
                <v-col cols="12" md="4" v-if="$can('show interview employee') || $can('show interview')">
                    <router-link class="custom-link" style="height: 100%;" :to="{name: 'EmployeeInterviewsIndex'}">
                        <v-hover v-slot:default="{ hover }">
                            <v-card :elevation="hover ? 16 : 2" style="height: 100%;">
                                <v-card-title>Durchgeführte Gespräche</v-card-title>
                                <v-card-text>
                                    Mitarbeitergespräche, welche durch Sie oder andere Führungskräfte durchgeführt wurden.
                                </v-card-text>
                                <v-card-actions v-if="$can('create interview employee')">
                                    <v-btn block color="secondary" :to="{ name: 'EmployeeInterviewsCreate'}"><v-icon>mdi-plus</v-icon>Neues Gespräch </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-hover>
                    </router-link>

                </v-col>
                <v-col cols="12" md="4" v-if="$can('show interview employee')">
                    <router-link class="custom-link" style="height: 100%;" :to="{name: 'EmployeeInterviewsEmployees'}">
                        <v-hover v-slot:default="{ hover }">
                            <v-card :elevation="hover ? 16 : 2" style="height: 100%;">
                                <v-card-title>Mitarbeiter</v-card-title>
                                <v-card-text>
                                    Mitarbeiter, mit denen Sie als Führungskraft dieses
                                    Jahr noch kein Gespräch geführt haben.
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </router-link>
                </v-col>
                <v-col cols="12" md="4" v-if="$can('show interview own')">
                    <router-link class="custom-link" style="height: 100%;" :to="{name: 'EmployeeInterviewsOwn'}">
                        <v-hover v-slot:default="{ hover }">
                            <v-card :elevation="hover ? 16 : 2" style="height: 100%;">
                                <v-card-title>Eigene Gespräche</v-card-title>
                                <v-card-text>
                                    Mitarbeitergespräche, die Ihre Führungskraft mit Ihnen geführt hat.
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </router-link>
                </v-col>
                <!--<v-col cols="12" md="4">
                    <router-link class="custom-link" style="height: 100%;" :to="{name: 'AuthLogin'}">
                        <v-hover v-slot:default="{ hover }">
                            <v-card :elevation="hover ? 16 : 2" style="height: 100%;">
                                <v-card-title>Auswertungen</v-card-title>
                                <v-card-text>
                                    Auswertung der einzelnen Kennzahlen.
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </router-link>
                </v-col>-->
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "user-area-employee-interview-dashboard-content"
    }
</script>

<style scoped>

</style>